import React, { memo, useState, useContext, useEffect, useRef } from "react";

import { Box, Divider } from "@mui/material";

import Tabla from "./Componentes/Tabla";

import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../Context/Auth/AuthContext";
import io from "socket.io-client";
import { socketUrl } from "../../../config/const";

import { Add } from "@mui/icons-material";

import BarraTablas from "../../components/Tablas/BarraTablas";
import ModalB from "../../components/Modal/ModalB";
import DialogOpciones from "../../components/Dialogs/DialogOpciones";
import { usePermiso } from "../../../hooks/usePermiso";
import { columns, objectDefault } from "./data";
const Base = (props) => {
  // DATA DEL STATE
  // REGISTROS O FILAS
  const [rows, setrows] = useState(null);
  // COLUMNAS

  // FUNCION QUE CREA EL OBJETO BUSCADOR
  const defaultFullBuscador = () => {
    const json = {};
    columns.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    return json;
  };

  // PAGINACION
  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  // FUNCION QUE OBTIENE LA DATA DE LA TABLA
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estadoRequest,
  ) => {
    try {
      console.log(orden);

      const res = await clienteAxios.get(
        `/inventario/pagination/detalle/inventario?cantidad=${cantidad}&page=${page}&search=${
          search ? search : ""
        }&input=${input ? input : ""}&orden=${orden ? orden : ""}&rucempresa=${
          rucempresa ? rucempresa : ""
        }&codigo=${props.codigo}`,
      );
      console.log({ res });
      return res;
    } catch (error) {
      console.log({ error });

      mostrarAlerta("Hubo un error");
    }
  };
  // FUNCION QUE COLOCA LA DATA EN EL STATE
  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estadoRequest,
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      estadoRequest,
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  // AGREGA MAS REGISTROS AL STATE
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  // REMPLAZA LA CONSULTA ACTUAL POR UNA NUEVA CON OTROS PARAMETROS
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estadoRequest,
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      estadoRequest,
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  // AGREGA UN REGISTRO AL STATE
  const agregarState = async (item) => {
    try {
      item.nuevo = true;
      const { editado, eliminado, ...rest } = item;

      setrows(
        [rest, ...rows].filter(
          (itemR) =>
            Number(item.cl_usuario.split("/+/")[1]) !== itemR[campoExport],
        ),
      );
    } catch (error) {}
  };

  // EDITA UN REGISTRO DEL STATE
  const editarState = async (item) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR[campoExport] === item[campoExport]) {
          item.editado = true;
          const { nuevo, eliminado, ...rest } = item;
          return rest;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };
  // ELIMINA UN REGISTRO DEL STATE
  const eliminarState = async (_id) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR[campoExport] === _id) {
          itemR.eliminado = true;
          const { nuevo, editado, ...rest } = itemR;
          return rest;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };
  // ELIMINA REGISTROS SELECICONADOS DEL STATE
  const eliminarSeleccionState = async (_ids) => {
    const resRows = rows.map((itemR) => {
      const existe = _ids.some((item) => {
        return item === itemR[campoExport];
      });
      if (existe) {
        itemR.eliminado = true;
        const { nuevo, editado, ...rest } = itemR;
        return rest;
      } else {
        return itemR;
      }
    });

    setrows(resRows);
  };
  // CAMBIA EL OBJETO ACTIVO DEL STATE GENERALMENTE PARA EDITAR

  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // NOMBRE DE LA TABLA
  const [tabla] = useState("detalles_inventar");
  // ITEM DEL SOCKET SE UTILIZA COMO REFERENCIA
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });
  // REFERENCIA DEL SOCKET
  const socket = useRef();
  // USEFFECT QUE ESCUCHUA LOS EVENTOS DEL SOCKET
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error",
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  // CUANDO CAMBIA EL OBJETO DEL SOCKET SE ESCUCHA AQUI Y SE DECIDE QUE HACER CON EL
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }
    if (item.tabla !== tabla) {
      return;
    }

    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item[campoExport]);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("DetallesInventario");
  const [estadoRequest] = useState("RIESGO");
  // ABRIR MODAL
  const [open, setopen] = useState(false);
  const [openModal, setopenModal] = useState(false);
  // BOOLEANO DE SI SE ESTA BUSCANDO O NO
  const [buscando, setbuscando] = useState(false);

  // STRING DE BUSQUEDA
  const [search, setsearch] = useState("");
  // BOOLEANO DE SI ESTA CARGANDO
  const [cargando, setcargando] = useState(false);
  // CAMPO POR EL CUAL SE FILTRAN LOS REGISTROS PARA EXPORTAR
  const [campoExport] = useState("numFactura");
  // ORDEN DE POR DEFECTO
  const [input, setinput] = useState({
    id: "subtotal",
    label: "ID",
    minWidth: 150,
    tipo: "string",
    propiedad: "subtotal",
  });
  const [ObjectoActivo, setObjetoActivo] = useState(objectDefault);
  // ARRAY DE EXPORTACION
  const [arrayExport, setarrayExport] = useState([]);
  // BOLLEANO DE SI ESTA ABIERTO EL DIALOG DE OPCIONES
  const [openDialogOpciones, setopenDialogOpciones] = useState(false);
  // ORDEN ASCENDENTE O DESCENDENTE
  const [orden, setorden] = useState(false);
  // CAMPOS DE BUSQUEDA EXPANDIDOS
  const [openMB, setopenMB] = useState(false);
  // OBJETO BUSCADOR
  const [fullBuscador, setfullBuscador] = useState(defaultFullBuscador());

  //pagina actual
  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // EVENTO QUE CAMBIA LA DATA DEL OBJETO BUSCADOR
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  // FUNCION DE BUSQUEDA AVANZADA
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest,
    );
    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };
  // FUNCION DE BUSQUEDA RAPIDA
  const handleSearch = async () => {
    setarrayExport([]);
    setcargando(true);
    setbuscando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      !orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest,
    );

    setPage(0);
    setcargando(false);
  };
  // FUNCION QUE PONE LA DATA DE POR DEFECTO O HACE UN REFRESH
  const funcionDefault = async () => {
    setcargando(true);
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      !orden,
      JSON.stringify(fullBRes),
      rucempresa,
      estadoRequest,
    );

    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };

  return (
    <Box>
      <DialogOpciones
        open={openDialogOpciones}
        setopen={setopenDialogOpciones}
        botones={[
          {
            tooltip: "Agregar",
            funcion: () => {
              setopen(true);
            },
            Icon: Add,
            color: "primary",
            id: 1,
            disabled: false,
          },
        ]}
        titulo={"Mas Opciones"}
      />
      {/* <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        LabelBuscador="Buscar Por: Nombre"
        funcionDefault={funcionDefault}
        ocultarMigasDePan
        
        botones={
          [
            // {
            //   tooltip: "Agregar",
            //   texto: "Agregar",
            //   funcion: () => {
            //     setopen(true);
            //   },
            //   disabled: false,
            //   Icon: Add,
            //   color: "primary",
            //   id: 1,
            //   ocultar: true,
            //   tipo: "icono",
            //   variante: "contained",
            //   size: "medium",
            //   sx: { marginRight: ".3rem" },
            // },
            // {
            //   tooltip: "Agregar",
            //   texto: "Agregar",
            //   funcion: () => {
            //     if (!tienePermiso("agregar")) {
            //       return alertaPermiso("agregar");
            //     }
            //     setopen(true);
            //   },
            //   disabled: false,
            //   Icon: Add,
            //   color: "primary",
            //   id: 2,
            //   ocultar: false,
            //   tipo: "boton",
            //   variante: "contained",
            //   size: "medium",
            //   sx: {},
            // },
          ]
        }
      /> */}
      <ModalB
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={"Busqueda avanzada (DetallesInventario)"}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        arrayProps={columns}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems=" stretch"
        width="100%"
      >
        <Box> </Box>
      </Box>
      <Divider />
      <Tabla
        //PAGINACION Y BUSQUEDA
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        search={search}
        input={input}
        orden={orden}
        setinput={setinput}
        setorden={setorden}
        cargando={cargando}
        setcargando={setcargando}
        fullBuscador={fullBuscador}
        //ESTADO
        rows={rows}
        columns={columns}
        pagination={pagination}
        getDataState={getDataState}
        obtenerState={obtenerState}
        addRowsState={addRowsState}
        remplazarRowsState={remplazarRowsState}
        arrayExport={arrayExport}
        setarrayExport={setarrayExport}
        socket={socket}
        campoExport={campoExport}
        estadoRequest={estadoRequest}
        tabla={tabla}
        //ROW
        open={open}
        setopen={setopen}
        setopenModal={setopenModal}
        setObjetoActivo={setObjetoActivo}
      />
      {/* {socket.current && (
        <Modal
          editar={true}
          seteditar={() => {}}
          setopen={setopenModal}
          open={openModal}
          ObjectoActivo={ObjectoActivo}
          changeObjetoActivoState={setObjetoActivo}
          socket={socket}
        />
      )} */}
    </Box>
  );
};

export default memo(Base);
